import React from "react";
import Network from "../components/Network/Network";
export default function NetworkPage() {
  return (
    <div className="page-layout">
      <Network />
    </div>
  );
}
